import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { SortOption, SORT_OPTIONS } from '../utils/sortUtils';

interface SortSelectorProps {
  value: SortOption;
  onChange: (option: SortOption) => void;
  disabled?: boolean;
  compact?: boolean;
  /** Custom sort options (defaults to SORT_OPTIONS for artwork) */
  sortOptions?: SortOption[];
}

/**
 * Dropdown selector for sorting artwork or collections in catalog views.
 * Follows the same pattern as CatalogSelector for consistency.
 */
export const SortSelector = ({
  value,
  onChange,
  disabled = false,
  compact = false,
  sortOptions = SORT_OPTIONS,
}: SortSelectorProps) => {
  // Create a unique key for the current sort option
  const getOptionKey = (option: SortOption) => `${option.field}|${option.direction}`;

  const handleChange = (event: SelectChangeEvent) => {
    const key = event.target.value;
    const selectedOption = sortOptions.find((opt) => getOptionKey(opt) === key);
    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return (
    <Select
      value={getOptionKey(value)}
      onChange={handleChange}
      disabled={disabled}
      size="small"
      sx={{ minWidth: compact ? 120 : 180 }}
      renderValue={() => value.label}
    >
      {sortOptions.map((option) => (
        <MenuItem key={getOptionKey(option)} value={getOptionKey(option)}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
